import host from './host.js'

const apiURL = (path = '/') => {
  const baseURL = host
  return `${baseURL}${path}`
}

export default apiURL
